export default () => ({
  /*默认参数*/

  defaultParams: {
    LanguageType: localStorage.getItem('lang') ? localStorage.getItem('lang') : 2,
    Channel: 'epermpc',
    // AreaType: localStorage.getItem('cityInfo') ? JSON.parse(localStorage.getItem('cityInfo')).AreaType : '',
    AreaType: localStorage.getItem('waysobj') ? JSON.parse(localStorage.getItem('waysobj')).AreaType : '',
    CurrentCity: localStorage.getItem('cityInfo') ? JSON.parse(localStorage.getItem('cityInfo')).CityID : '',
    TempId: localStorage.getItem('TempId') ? localStorage.getItem('TempId') : '',
    DeliveryMode: localStorage.getItem('waysobj') ? JSON.parse(localStorage.getItem('waysobj')).DeliveryMode : '',
    // Token:  localStorage.getItem('Token') ? localStorage.getItem('Token') : ''
  },
  NewdefaultParams:{
    AreaType:localStorage.getItem('waysobj') ? JSON.parse(localStorage.getItem('waysobj')).AreaType : '',
    LanguageType: localStorage.getItem('lang') ? localStorage.getItem('lang') : 2,
    Channel:"epermpc"
  },
  /*全局本地语言*/
  epermarket_lang: {
    type: 'EPERMARKET_LANG',
    default: 'zh_cn',
    locales: [
      { locale: "en_us", lang: "English", value: 2 },
      { locale: "fr_fr", lang: "Français", value: 3 },
      { locale: "zh_cn", lang: "中文", value: 1 }
    ],
    locale: 'zh_cn'
  },
  isIndex: 0,
  shopcarInfo: {},
  /*用户信息*/
  epermarket_user_info: '',
  // 语言类型
  langType: 1,
  // 地区类型
  areaType: 1,
  // 城市id
  CurrentCity: 1,
  //是否需要短暂显示购物车
  needShowCartToSeconds: false,
  MessageConfig:{
    showMessage:false,
    msg:""
  }
})



// WEBPACK FOOTER //
// ./src/store/state.js